var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout-2_svgrepo.com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.50146 5.83329C7.51156 4.02077 7.59193 3.03918 8.23225 2.39886C8.96451 1.66663 10.143 1.66663 12.5 1.66663H13.3333C15.6903 1.66663 16.8689 1.66663 17.6011 2.39886C18.3333 3.13109 18.3333 4.3096 18.3333 6.66663V13.3333C18.3333 15.6903 18.3333 16.8688 17.6011 17.601C16.8689 18.3333 15.6903 18.3333 13.3333 18.3333H12.5C10.143 18.3333 8.96451 18.3333 8.23225 17.601C7.59193 16.9607 7.51156 15.9791 7.50146 14.1666",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.4998 10H1.6665M1.6665 10L4.58317 7.5M1.6665 10L4.58317 12.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.856471dd7bc3a821c9b155c1c3e0c6f0.svg";
export { ForwardRef as ReactComponent };